import { Link } from "react-router-dom";
import time from 'service/time'

function LeftCard({ root, title, postArr }) {
    return (
        <div className="px-4 py-3" >
            <span style={{ textAlign: 'left' }}>
                <Link to={`/${root}`} style={{ textDecoration: "none", color: "black" }}>
                    <h5 className="d-flex">{title}</h5>
                </Link>
            </span>
            {postArr.length !== 0 ? postArr.map(item =>
                <Link to={`/${root}/${item.id}`} style={{ textDecoration: "none", color: "black" }}>
                    <div className="row my-1">
                        <div className="col-md-9 text-truncate " style={{ textAlign: 'left', fontSize: "14px" }}>
                            {item.title}
                        </div>
                        <div className="col-md-3 text-truncate " style={{ textAlign: 'center', fontSize: "14px" }}>
                            {time.parseDate(item.date)}
                        </div>
                    </div>
                </Link>
            ) : <div>비어 있음</div>}
        </div>

    );
}

export default LeftCard;